import React from 'react'
import { NoticeBox } from '@core/Components/NoticeBox'

export const InvalidBetsMessage = () => {
  return (
    <NoticeBox
      title='Unable to proceed as bets are invalid'
      noticeBoxType='Error'
      hasBorder={false}
    />
  )
}
